// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import axios from "./lib/axios";
import VueProgressBar from "vue-progressbar";
import gtagjs from "vue-gtagjs";

import { STORAGE_KEY } from "./store/state";

import embers from "./plugins/embers.js";

/* App scss */
import { } from "./assets/bootstrap.scss";
import { } from "./assets/select2.scss";
import { } from "./assets/vue-multiselect.scss";

import { } from "./assets/embersds.scss";
import { } from "./assets/light.scss";
import { } from "./assets/dark.scss";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

Vue.use(VueProgressBar, {
  color: "#577492",
  failedColor: "#B74934",
  thickness: "4px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 0
  }
});
Vue.use(embers);

gtagjs(router, process.env.VUE_APP_GA_TRACKING_ID);

/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
window.Vue = new Vue({
  store,
  router,
  render: h => h(App),
  created() {
    /* eslint-disable no-undef */
    $(window).focus(e => {
      if (localStorage.getItem(STORAGE_KEY)) {
        store.commit(
          "LOAD_SESSION",
          JSON.parse(localStorage.getItem(STORAGE_KEY))
        );
      }
    });
  }
}).$mount("#app");
